import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import * as DateHelpers from './DateHelpers';

interface GenericListItem {
    id: number;
    name: string;
}

const ReportCustomerEmailsData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [customers, setCustomers] = React.useState<GenericListItem[]>([]);
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");
    const [customerId, setCustomerId] = React.useState(-1);

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                getCustomers(token??"", user.sub);
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const getCustomers = (token: string, subId: string) => {
        axios.get('api/Customer/GetCustomersForDropdown?SubId=' + subId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setCustomers(res.data);
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const handleStartDateChange = (e: any) => {
        let error = errors;
        delete error["startDate"];
        setErrors(error);

        setStartDate(e.target.value);
    }

    const handleEndDateChange = (e: any) => {
        let error = errors;
        delete error["endDate"];
        setErrors(error);

        setEndDate(e.target.value);
    }

    const handleCustomerChange = (e: any) => {
        let custId = e.target.value * 1;
        setCustomerId(custId);
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data
        runRpt();
    }

    const validate = () => {
        let error: any = {};
        let formIsValid = true;

        if (!startDate) {
            formIsValid = false;
            error["startDate"] = "Start Date is required";
        } else if (!DateHelpers.isValidDate(startDate)) {
            errors["startDate"] = "Valid Start Date is Required";
            formIsValid = false;
        }

        if (!endDate) {
            formIsValid = false;
            error["endDate"] = "End Date is required";
        } else if (!DateHelpers.isValidDate(endDate)) {
            errors["endDate"] = "Valid End Date is Required";
            formIsValid = false;
        }

        if (startDate && endDate && endDate < startDate) {
            formIsValid = false;
            error["startDate"] = "Start Date must be <= End Date";
        }

        setErrors(error);
        return formIsValid;
    }

    const runRpt = () => {
        if (validate()) {
            var url = "/report/CustomerEmails/" + startDate + "/" + endDate + "/" + customerId + "/-1/-1";
            window.open(url, '_blank');
        } else {
            toast.error("Please fix validation errors on screen before running report!");
        }
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Customer Emails Report</h1>
            </div>
            <div>
                <label className="input-group" htmlFor="startDate">
                    <span className="label">Start Date</span>
                    <input type='date' id="startDate" name="startDate" className='input' value={startDate} onChange={(e) => handleStartDateChange(e)}></input>
                </label>
                <span className={errors["startDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["startDate"]}</span>

                <label className="input-group" htmlFor="endDate">
                    <span className="label">End Date</span>
                    <input type='date' id="endDate" name="endDate" className='input' value={endDate} onChange={(e) => handleEndDateChange(e)}></input>
                </label>
                <span className={errors["endDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["endDate"]}</span>

                <label className="input-group" htmlFor="customerId">
                    <span className="label">Customer</span>
                    <select className="select" id="customerId" name="customerId" value={customerId} onChange={(e) => handleCustomerChange(e)}>
                        <option defaultValue="-1" value="-1"></option>
                        {customers.map(customer =>
                            <option key={customer.id} value={customer.id}>{customer.name}</option>
                        )};
                    </select>
                </label>

                <button className="defaultbutton marginLeftLabel" type='button' onClick={runReport}>Run Report</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

}

export default ReportCustomerEmailsData;